<form [formGroup]="taskForm">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-4">
          <div class="mb-1">
            <label for="taskName" class="form-label mb-1">Task Name
              @if (getFieldInfo('taskName'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <input class="form-control p-2" type="text" formControlName="taskName" id="taskName" appSpellCheck>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-1">
            <label for="projectName" class="form-label mb-1">Project Name
              @if (getFieldInfo('projectName'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <input class="form-control p-2" type="text" formControlName="projectName"
              id="projectName">

          </div>
        </div>
        <!-- <div class="col-sm-4" *ngIf="!taskAssignDialog">
        <div class="mb-1">
          <label for="quickbookId" class="form-label mb-1">Task QuickBook Id</label>
          <input class="form-control p-2" type="text" readonly formControlName="qbTaskId"
            id="quickbookId">

        </div>
      </div> -->
      @if (!taskAssignDialog) {
        <div class="col-sm-4">
          <div class="mb-1">
            <label for="actualTime" class="form-label mb-1">Actual Time(HH:MM)
              @if (getFieldInfo('actualTime'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <input class="form-control p-2" type="number" step="any" formControlName="actualTime"
              id="actualTime">
          </div>
        </div>
      }
      @if (!taskAssignDialog) {
        <div class="col-sm-4">
          <div class="mb-1">
            <label for="isCompleted" class="form-label mb-1">Task Completed
              @if (getFieldInfo('isCompleted'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
              </label><span style="color:var(--al-danger);">*</span>
              <select #isCompletedSelect class="form-select" id="isCompleted" formControlName="isCompleted" (change)="isCompletedOnchange(isCompletedSelect.value)">
                <option [value]="" selected>Select</option>
                <option value="Yes" selected>Yes</option>
                <option value="No" selected>No</option>
              </select>
            </div> @if (submitted && isCompleted && isCompleted.invalid) {
            <span style="color:var(--al-danger)">Task Completed is
            required</span>
          }
        </div>
      }
      @if (!taskAssignDialog) {
        <div class="col-sm-4">
          <div class="mb-1">
            <label class="form-label mb-1">Rate Type Code
              @if (getFieldInfo('rateTypeCode'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <input class="form-control p-2" type="text" step="any" formControlName="rateTypeCode"
              id="rateTypeCode">
          </div>
        </div>
      }
      @if (!taskAssignDialog) {
        <div class="col-sm-4">
          <div class="mb-1">
            <label for="isEnforceMaximum" class="form-label mb-1">Enforced Max
              Time
              @if (getFieldInfo('isEnforceMaximum'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <select class="form-select" formControlName="isEnforceMaximum">
              <option [value]="" selected>Select</option>
              <option value="Yes" selected>Yes</option>
              <option value="No" selected>No</option>
            </select>
          </div>
        </div>
      }
      @if (!showCountry && !taskAssignDialog) {
        <div class="col-sm-4">
          <div class="mb-1">
            <label for="countryRelated" class="form-label mb-1">Country Related
              @if (getFieldInfo('countryRelated'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <select class="form-select" formControlName="countryRelated">
              <option [value]="" selected>Select</option>
              <option value="Yes" selected>Yes</option>
              <option value="No" selected>No</option>
            </select>
          </div>
        </div>
      }
      @if (!showStateCode && !taskAssignDialog) {
        <div class="col-sm-4">
          <div class="mb-1">
            <label for="isStateRelated" class="form-label mb-1">State Related
              @if (getFieldInfo('isStateRelated'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <select class="form-select" formControlName="isStateRelated">
              <option [value]="" selected>Select</option>
              <option value="Yes" selected>Yes</option>
              <option value="No" selected>No</option>
            </select>
          </div>
        </div>
      }
      @if (!taskAssignDialog) {
        <div class="col-sm-4">
          <div class="mb-1">
            <label class="form-label mb-1"> Task Status
              @if (getFieldInfo('statusCode'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <input class="form-control p-2" type="text" readonly formControlName="statusCode"
              id="statusCode">
          </div>
        </div>
      }

      @if (showStateCode && !taskAssignDialog) {
        <div class="col-xl-4">
          <div class="mb-1">
            <label class="form-label mb-1">State
              @if (getFieldInfo('stateCode'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
              </label><span style="color:var(--al-danger);">*</span>
              @if (taskForm.getRawValue().country === 'United States' && taskForm.getRawValue().countryRelated === 'Yes') {
                <p-dropdown
                  class="form-select-wrapper"
                  formControlName="stateCode"
                  [options]="stateCodeMapList"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  [filter]="true"
                  [style]="{'width':'100%'}"
                  placeholder="Select"
                  >
                </p-dropdown>
              }
              @if (taskForm.getRawValue().country === 'Canada' && taskForm.getRawValue().countryRelated === 'Yes') {
                <p-dropdown
                  class="form-select-wrapper"
                  formControlName="stateCode"
                  [options]="canadaStateList"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  [filter]="true"
                  [style]="{'width':'100%'}"
                  placeholder="Select"
                  >
                </p-dropdown>
              }
              @if (taskForm.getRawValue().country !== 'Canada' && taskForm.getRawValue().country !== 'United States' && taskForm.getRawValue().countryRelated === 'Yes') {
                <input
                  class="form-control p-2"
                  type="text"
                  value="N/A"
                  disabled
                  >
              }
              @if (taskForm.getRawValue().countryRelated !== 'Yes') {
                <p-dropdown
                  class="form-select-wrapper"
                  formControlName="stateCode"
                  [options]="stateCodeMapList"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  [filter]="true"
                  [style]="{'width':'100%'}"
                  placeholder="Select"
                  >
                </p-dropdown>
              }
              @if (submitted && stateCode && stateCode.invalid) {
                <span style="color:var(--al-danger)">State is required</span>
              }
            </div>
          </div>
        }
        @if (showCountry &&!taskAssignDialog) {
          <div class="col-sm-4">
            <div class="mb-1">
              <label class="form-label mb-1">Country
                @if (getFieldInfo('country'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" readonly formControlName="country"
                id="statusCode">
              @if (submitted && country && country.invalid) {
                <span style="color:var(--al-danger)">Country
                is required</span>
              }
            </div>
          </div>
        }

        <div class="col-sm-4">
          <div class="mb-1">
            <label for="timeEstimate" class="form-label mb-1">Estimated Time(HH:MM)
              @if (getFieldInfo('timeEstimate'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <span style="color:var(--al-danger);">*</span>
            <!-- <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24" [timeOnly]="true"
            formControlName="timeEstimate" [defaultDate]="defaultTime">
          </p-calendar> -->
          <input class="form-control p-2" type="text" step="any" formControlName="timeEstimate"
            >
            @if (submitted && timeEstimate && timeEstimate.invalid) {
              <span style="color:var(--al-danger)"
                >Estimated Time
              is required</span>
            }
          </div>
        </div>

        @if (lpcdashboard || !onlytk) {
          <div [ngClass]="taskAssignDialog?'col-xl-2':'col-sm-4'">
            <div class="mb-1">
              <label for="maxTime" class="form-label mb-1">Max Time(HH:MM)
                @if (getFieldInfo('maxTime'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <!-- <span style="color:var(--al-danger);">*</span> -->
              <input class="form-control p-2" type="text" step="any" formControlName="maxTime"
                id="maxTime">
              <!-- <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24" [timeOnly]="true"
              formControlName="maxTime" [defaultDate]="defaultTime">
            </p-calendar> -->
            <!-- <p>{{maxTime}}{{maxTime.invalid}}</p> -->
            @if (submitted && taskForm.get('maxTime').errors?.required) {
              <span style="color:var(--al-danger)">Max Time
              is required</span>
            }
          </div>
        </div>
      }
      @if (!taskAssignDialog) {
        <div class="col-sm-4">
          <div class="mb-1">
            <label for="isBillable" class="form-label mb-1">Billable
              @if (getFieldInfo('isBillable'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label><span
          style="color:var(--al-danger);">*</span>
          <select class="form-select" id="isBillable" formControlName="isBillable">
            <option [value]="" selected>Select</option>
            <option value="Yes" >Yes</option>
            <option value="No" >No</option>
          </select>
          @if (submitted && isBillable && isBillable.invalid) {
            <span style="color:var(--al-danger)">Billable
            is required</span>
          }
        </div>
      </div>
    }
    @if (!taskAssignDialog) {
      <div class="col-sm-4">
        <div class="mb-1">
          <label for="consolidatedTimeRecords" class="form-label mb-1">Consolidated Time
            Records
            @if (getFieldInfo('consolidatedTimeRecords'); as info) {
              @if (info.showInformation === 'Yes' && info.informationText) {
                <info-tooltip [infoText]="info.informationText"></info-tooltip>
              }
            }
            </label><span style="color:var(--al-danger);">*</span>
            <select  class="form-select" id="consolidatedTimeRecords" formControlName="consolidatedTimeRecords" >
              <option value="" selected>Select</option>
              <option value="Yes" >Yes</option>
              <option value="No" >No</option>
            </select>
            @if (submitted && consolidatedTimeRecords && consolidatedTimeRecords.invalid) {
              <span style="color:var(--al-danger)"
                >Consolidated
                Time Records is
              required</span>
            }
          </div>
        </div>
      }
      <div [ngClass]="taskAssignDialog?'col-xl-2':'col-sm-4'">
        <div class="mb-1">
          <label for="isRequireEstimate" class="form-label mb-1">Required Estimate
            @if (getFieldInfo('isRequireEstimate'); as info) {
              @if (info.showInformation === 'Yes' && info.informationText) {
                <info-tooltip [infoText]="info.informationText"></info-tooltip>
              }
            }
          </label><span
        style="color:var(--al-danger);">*</span>
        <select class="form-select" id="isRequireEstimate" formControlName="isRequireEstimate">
          <option value="" selected>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        @if (submitted && isRequireEstimate && isRequireEstimate.invalid) {
          <span style="color:var(--al-danger)"
            >Required
            Estimate is
          required</span>
        }
      </div>
    </div>

    @if (!taskAssignDialog) {
      <div class="col-sm-4">
        <div class="mb-1">
          <label for="isApprovalRequired" class="form-label mb-1">Approval Required
            @if (getFieldInfo('isApprovalRequired'); as info) {
              @if (info.showInformation === 'Yes' && info.informationText) {
                <info-tooltip [infoText]="info.informationText"></info-tooltip>
              }
            }
            </label><span style="color:var(--al-danger);">*</span>
            <select class="form-select" id="isApprovalRequired" (change)="onIsApprovalRequiredChange($event)"
              formControlName="isApprovalRequired">
              <option value="" selected>Select</option>
              <option value="Yes" >Yes</option>
              <option value="No" >No</option>
            </select>
            @if (submitted && isApprovalRequired && isApprovalRequired.invalid) {
              <span style="color:var(--al-danger)"
                >Approval
              Required is required</span>
            }
          </div>
        </div>
      }
      <div class="col-sm-4">
        <div class="mb-1">
          <label for="taskDueDate" class="form-label mb-1">Due Date
            @if (getFieldInfo('taskDueDate'); as info) {
              @if (info.showInformation === 'Yes' && info.informationText) {
                <info-tooltip [infoText]="info.informationText"></info-tooltip>
              }
            }
          </label><span
        style="color:var(--al-danger);">*</span>
        <!-- <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
        yearRange="2010:2030" dateFormat="mm/dd/yy" formControlName="taskDueDate"
        (onSelect)="isValidDueDate()">
      </p-calendar> -->
      <input class="form-control p-2" type="text" formControlName="taskDueDate" >
      <!-- <span style="color:var(--al-danger)" *ngIf="dueDateMaxError && !dueDateMinError">Due Date cannot exceed Project Due Date {{taskForm.value.projectDueDate}} </span>
      <span style="color:var(--al-danger)" *ngIf="dueDateMinError && !dueDateMaxError">Due Date cannot be less than task Created Date {{taskForm.value.createdOn}} </span> -->
      <!-- <span style="color:var(--al-danger)" *ngIf="dueDateError">Due Date should be in the range of
    {{taskForm.getRawValue().createdOn}} - {{taskForm.getRawValue().projectDueDate}} </span> -->
    @if (dueDateError) {
      <span style="color:var(--al-danger)">Due Date should be after Task Created Date [
      {{taskForm.getRawValue().createdOn}}]  </span>
    }
    @if (dueDateExceeded) {
      <span style="color:var(--al-success)">Project Due Date Extended [
      {{taskForm.getRawValue().taskDueDate}}]  </span>
    }
    @if (submitted && !dueDateError && taskDueDate && taskDueDate.invalid) {
      <span style="color:var(--al-danger)"
        >Due
      Date is required</span>
    }
  </div>
</div>
@if (!taskAssignDialog) {
  <div class="col-sm-4">
    <div class="mb-1">
      <label for="openEnded" class="form-label mb-1">Open Ended
        @if (getFieldInfo('openEnded'); as info) {
          @if (info.showInformation === 'Yes' && info.informationText) {
            <info-tooltip [infoText]="info.informationText"></info-tooltip>
          }
        }
      </label><span
    style="color:var(--al-danger);">*</span>
    <select class="form-select" id="openEnded" formControlName="openEnded">
      <option [value]="" selected>Select</option>
      <option value="Yes" >Yes</option>
      <option value="No" >No</option>
    </select>
    @if (submitted && openEnded && openEnded.invalid) {
      <span style="color:var(--al-danger)">Open
        Ended is
      required</span>
    }
  </div>
</div>
}
@if (!taskAssignDialog) {
  <div class="col-sm-4">
    <div class="mb-1">
      <label for="openEnded" class="form-label mb-1">Quantity Type
        @if (getFieldInfo('quantityType'); as info) {
          @if (info.showInformation === 'Yes' && info.informationText) {
            <info-tooltip [infoText]="info.informationText"></info-tooltip>
          }
        }
      </label>
      <select class="form-select" id="openEnded" readonly formControlName="quantityType">
        <option [value]="" selected>Select</option>
        <option value="State">State</option>
        <option value="Number">Number</option>
      </select>
    </div>
  </div>
}
@if (showQuantityState && !taskAssignDialog) {
  <div class="col-sm-4">
    <div class="mb-1">
      <label for="quantityState" class="form-label mb-1">Quantity
        @if (getFieldInfo('quantityState'); as info) {
          @if (info.showInformation === 'Yes' && info.informationText) {
            <info-tooltip [infoText]="info.informationText"></info-tooltip>
          }
        }
      </label>
      @if (taskForm.value.quantityRelated=='Yes') {
        <span style="color:var(--al-danger);">*</span>
      }
      <p-multiSelect [maxSelectedLabels]="10000" appendTo="body" defaultLabel="Select State"
        formControlName="quantityState" [options]="stateCodeMapList" optionLabel="label"
      optionValue="value"></p-multiSelect>
      @if (submitted && quantityState && quantityState.invalid ) {
        <span style="color:var(--al-danger)">Quantity
        is required</span>
      }
    </div>
  </div>
}
@if (!showQuantityState && !taskAssignDialog) {
  <div class="col-sm-4">
    <div class="mb-1">
      <label for="quantityNumber" class="form-label mb-1">Quantity
        @if (getFieldInfo('quantityNumber'); as info) {
          @if (info.showInformation === 'Yes' && info.informationText) {
            <info-tooltip [infoText]="info.informationText"></info-tooltip>
          }
        }
      </label>
      @if (taskForm.value.quantityRelated=='Yes') {
        <span style="color:var(--al-danger);">*</span>
      }
      <input class="form-control p-2" type="number" formControlName="quantityNumber"
        id="quantityNumber">
      @if (submitted && quantityNumber && quantityNumber.invalid ) {
        <span style="color:var(--al-danger)">Quantity
        is required</span>
      }
    </div>
  </div>
}
<div class="col-sm-4">
  <div class="mb-1">
    <label for="dueDaySlot" class="form-label mb-1">Due Day Slot
      @if (getFieldInfo('dueDaySlot'); as info) {
        @if (info.showInformation === 'Yes' && info.informationText) {
          <info-tooltip [infoText]="info.informationText"></info-tooltip>
        }
      }
    </label>
    <select class="form-select" id="dueDaySlot" formControlName="dueDaySlot">
      <option [value]="" selected>Select</option>
      <option value="Morning">Morning</option>
      <option value="Afternoon">Afternoon</option>
      <option value="Evening">Evening</option>
    </select>
  </div>
</div>
@if (!taskAssignDialog && (lpcdashboard || !onlytk)) {
  <div class="col-sm-4">
    <div class="mb-1">
      <label for="tkRating" class="form-label mb-1">TK Rating
        @if (getFieldInfo('tkRating'); as info) {
          @if (info.showInformation === 'Yes' && info.informationText) {
            <info-tooltip [infoText]="info.informationText"></info-tooltip>
          }
        }
      </label>@if (tkRatingMand) {
      <span style="color:var(--al-danger);">*</span>
    }
    <select class="form-select" id="tkRating" formControlName="tkRating">
      <option [value]="" selected>Select</option>
      <option value="1" >1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
    </select>
  </div>
  @if (submitted && tkRating && tkRating.invalid) {
    <span style="color:var(--al-danger)"
      >TK Rating is
    required</span>
  }
</div>
}
@if (!taskAssignDialog) {
  <div class="col-sm-4">
    <div class="mb-1">
      <label for="holdTimeUntilComp" class="form-label mb-1">Hold Time Until Completed
        @if (getFieldInfo('holdTimeUntilComp'); as info) {
          @if (info.showInformation === 'Yes' && info.informationText) {
            <info-tooltip [infoText]="info.informationText"></info-tooltip>
          }
        }
        </label><span style="color:var(--al-danger);">*</span>
        <select class="form-select" id="holdTimeUntilComp" formControlName="holdTimeUntilComp">
          <option value="" selected>Select</option>
          <option value="Yes" >Yes</option>
          <option value="No" >No</option>
        </select>
        @if (submitted && holdTimeUntilComp && holdTimeUntilComp.invalid) {
          <span style="color:var(--al-danger)"
            >Hold
            Time Until Completed is
          required</span>
        }
      </div>
    </div>
  }

  @if (!taskAssignDialog) {
    <div class="col-sm-4">
      <div class="mb-1">
        <label for="approver" class="form-label mb-1">Task Approver
          @if (getFieldInfo('approver'); as info) {
            @if (info.showInformation === 'Yes' && info.informationText) {
              <info-tooltip [infoText]="info.informationText"></info-tooltip>
            }
          }
        </label><span
      style="color:var(--al-danger);">*</span>
      <p-dropdown
        formControlName="approver"
        [options]="lpcUsersList"
        optionLabel="mainEmail"
        optionValue="id"
        [showClear]="true"
        [filter]="true"
        [style]="{'width':'100%'}"
        placeholder="Select Task Approver">
      </p-dropdown>
      @if (submitted && approver && approver.invalid) {
        <span style="color:var(--al-danger)">
        Task Approver is required</span>
      }
    </div>
  </div>
}
<div class="col-sm-4" >
  <div class="mb-1">
    <label for="practiceAreaCode" class="form-label mb-1">Practice Area
      @if (getFieldInfo('practiceAreaCode'); as info) {
        @if (info.showInformation === 'Yes' && info.informationText) {
          <info-tooltip [infoText]="info.informationText"></info-tooltip>
        }
      }
    </label>
    <select class="form-select" readonly formControlName="practiceAreaCode">
      <option value="" selected>Select</option>
      @for (area of userTkPracticeAreas; track area) {
        <option [ngValue]="area.description"
          [selected]="area.description== taskForm.value.practiceAreaCode">{{area.description}}
        </option>
      }
    </select>
    <!-- <span style="color:var(--al-danger)" *ngIf="submitted && practiceAreaCode && practiceAreaCode.invalid">
  Practice Area is required</span> -->
</div>
</div>
<!-- <div class="col-sm-4" *ngIf="!taskAssignDialog">
<div class="mb-1">
  <label for="approved" class="form-label mb-1">Task Approved To Assign</label><span
style="color:var(--al-danger);">*</span>
<select class="form-select" id="approved" formControlName="approved">
  <option [value]="" selected>Select</option>
  <option value="Yes" selected>Yes</option>
  <option value="No" selected>No</option>
</select>
<span style="color:var(--al-danger)" *ngIf="submitted && approved && approved.invalid">Approved is
required</span>
</div>
</div> -->
<div class="col-xl-2">
  <div class="mb-1">
    <label for="progress" class="form-label mb-1">Task Progress
      @if (getFieldInfo('progress'); as info) {
        @if (info.showInformation === 'Yes' && info.informationText) {
          <info-tooltip [infoText]="info.informationText"></info-tooltip>
        }
      }
    </label>
    <input class="form-control p-2" type="text" formControlName="progress"
      id="progress" disabled>
  </div>
</div>
<div class="col-xl-2">
  <div class="mb-1">
    <label for="reviewStatus" class="form-label mb-1">Review Status
      @if (getFieldInfo('reviewStatus'); as info) {
        @if (info.showInformation === 'Yes' && info.informationText) {
          <info-tooltip [infoText]="info.informationText"></info-tooltip>
        }
      }
    </label>
    <select class="form-select" formControlName="reviewStatus">
      <option [value]="" selected>Select</option>
      @for (status of reviewstatuslist; track status) {
        <option [ngValue]="status.value"
          [selected]="status.value == taskForm.value.reviewStatus">{{status.label}}
        </option>
      }
    </select>
  </div>
</div>
<div class="col-sm-4">
  <div class="mb-1">
    <label for="description" class="form-label mb-1">Description
      @if (getFieldInfo('description'); as info) {
        @if (info.showInformation === 'Yes' && info.informationText) {
          <info-tooltip [infoText]="info.informationText"></info-tooltip>
        }
      }
    </label>
    <input class="form-control p-2" type="text" formControlName="description"
      id="description" appSpellCheck>
  </div>
</div>
<div class="col-xl-4">
  <div class="mb-1">
    <label class="form-label">Non Billable Reason
      @if (getFieldInfo('nonBillableReason'); as info) {
        @if (info.showInformation === 'Yes' && info.informationText) {
          <info-tooltip [infoText]="info.informationText"></info-tooltip>
        }
      }
    </label>
    <p-dropdown formControlName="nonBillableReason"
                            [options]="[
                                {label: 'Pre-Invoiced', value: 'Pre-Invoiced'},
                                {label: 'Managed Service Project', value: 'Managed Service Project'},
                                {label: 'Internal or Administrative Task', value: 'Internal or Administrative Task'},
                                {label: 'Error Correction', value: 'Error Correction'},
                                {label: 'Client Courtesy', value: 'Client Courtesy'},
                                {label: 'Business Development', value: 'Business Development'},
                                {label: 'Knowledge Management', value: 'Knowledge Management'},
                                {label: 'Professional Development', value: 'Professional Development'},
                                {label: 'Marketing and Thought Leadership', value: 'Marketing and Thought Leadership'},
                                {label: 'Fixed Fee Project', value: 'Fixed Fee Project'}
                            ]"
      appendTo="body"
      optionLabel="label"
      optionValue="value"
      [showClear]="true"
      [filter]="true"
      [style]="{'width':'100%'}"
      placeholder="Select Non Billable Reason">
    </p-dropdown>
  </div>
</div>
<div class="col-sm-4">
  <div class="mb-1">
    <label for="notes" class="form-label mb-1">Task Notes
      @if (getFieldInfo('notes'); as info) {
        @if (info.showInformation === 'Yes' && info.informationText) {
          <info-tooltip [infoText]="info.informationText"></info-tooltip>
        }
      }
    </label>
    <textarea placeholder="" class="form-control" formControlName="notes" appSpellCheck></textarea>
  </div>
</div>
@if (!taskAssignDialog) {
  <div class="col-sm-4">
    <div class="mb-1">
      @if (!viewOnly) {
        <label for="driveLink" class="form-label mb-1">One Drive Link</label>
      }
      @if (viewOnly) {
        <span>
          @if (!taskForm.get('driveLink').value) {
            <span>Onedrive Link</span>
          }
          @if (taskForm.get('driveLink').value) {
            <a [href]="taskForm.get('driveLink').value" target="_blank">Onedrive Link</a>
          }
        </span>
      }
      @if (!viewOnly) {
        <textarea placeholder="" class="form-control" formControlName="driveLink" appSpellCheck></textarea>
      }
    </div>
  </div>
}
@if (taskAssignDialog || enableDeleteTask) {
  <div class="col-sm-4">
    <div class="mb-1">
      <label for="stateDesc" class="form-label mb-1">State
        @if (getFieldInfo('stateDesc'); as info) {
          @if (info.showInformation === 'Yes' && info.informationText) {
            <info-tooltip [infoText]="info.informationText"></info-tooltip>
          }
        }
      </label>
      <input class="form-control p-2" type="text" formControlName="stateDesc"
        id="stateDesc">
    </div>
  </div>
}
@if (enableReassignTask) {
  <div class="col-sm-4">
    <div class="mb-1">
      <label for="assignedTkUser" class="form-label mb-1">Assigned User</label>
      <input class="form-control p-2" type="text" [value]="assignedTkUserName" disabled
        id="assignedTkUser">
    </div>
  </div>
}
@if (taskAssignDialog) {
  <div class="col-xl-2">
    <div style="height: 40%;"></div>
    <div class="form-check mb-1">
      <input class="form-check-input" id="isIncludeToday" type="checkbox" [(checked)]="includeToday"
        [disabled]="viewTaskAssignmentDialog"
        (change)="includeTodayAssignment(taskForm.value.id,$event)">
      <label class="form-check-label" for="isIncludeToday">
        Include Today
        @if (getFieldInfo('isIncludeToday'); as info) {
          @if (info.showInformation === 'Yes' && info.informationText) {
            <info-tooltip [infoText]="info.informationText"></info-tooltip>
          }
        }
      </label>
    </div>
  </div>
}

</div>

@if (!viewOnly && !taskAssignDialog) {
  <div class="row">
    <div class="col-xl-12">
      <div class="button-items" style="float: right;">
        <a class="btn btn-primary" (click)="saveTask()"> Update @if (btnLoading) {
          <i
          style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
        }</a>
        <a class="btn btn-secondary" (click)="closeDialog()"> Cancel </a>
      </div>
    </div>
  </div>
}
</div>

</div>
</form>
